import { useEffect, useState } from 'react';
import { fetchNextSlots } from '../annuaire/tunnel/v2Api';

/**
 * Le prochain horaire libre de N ateliers du listing, en un seul appel
 * (FIXERLIGHT-084, contrat FIXERLIGHT-055 du dépôt api). `shopIds` change à
 * chaque nouvelle liste d'ateliers réservables ; ce hook ne rappelle l'api
 * QUE quand cette liste change réellement (comparée par sa forme triée et
 * dédupliquée, pas par référence de tableau, qui change à chaque rendu).
 *
 * Ni le filtre « réservable en ligne » ni le tri choisi par le visiteur ne
 * doivent redéclencher un appel : `AnnuaireCity` passe les ids de TOUS les
 * ateliers réservables de la ville, une fois, pas la sélection filtrée.
 *
 * Défensif comme `useShopsCities` : pas d'appel côté serveur (SSR), et un
 * échec réseau laisse simplement l'objet vide — aucune carte n'affiche de
 * prochain horaire, mais rien ne casse le listing pour ça.
 *
 * @param {Array<number|string>} shopIds
 * @return {Object<number, string>} next_slot ISO 8601 Zulu, par shop_id.
 */
export default function useNextSlots(shopIds) {
  const [nextSlotByShopId, setNextSlotByShopId] = useState({});

  // Clé stable : deux appels avec les mêmes ids, dans un ordre différent,
  // ne doivent pas redéclencher l'effet (le tri visiteur change l'ordre des
  // ids affichés sans changer QUELS ateliers sont réservables).
  const key = [...new Set((shopIds || []).map(Number))].sort().join(',');

  useEffect(() => {
    if (typeof window === 'undefined' || key === '') {
      setNextSlotByShopId({});
      return undefined;
    }

    let active = true;

    fetchNextSlots(key.split(',').map(Number))
      .then((byShopId) => {
        if (active) setNextSlotByShopId(byShopId);
      })
      .catch((err) => {
        if (active) {
          console.error('[useNextSlots] fetch failed:', err);
          setNextSlotByShopId({});
        }
      });

    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return nextSlotByShopId;
}
